import { inheritsLoose as _inheritsLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import FormSearch from '../FormSearch/index.js';
import FormInput from '../FormInput/index.js';

var _excluded = ["allowMultiple", "autoFocus", "className", "debugMode", "id", "labelKey", "minLength", "maxResults", "placeholder", "notifyOnChange"],
  _excluded2 = ["inputRef", "referenceElementRef"];
var Async = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Async, _Component);
  function Async(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.cache = {};
    _this.typeaheadRef = /*#__PURE__*/React.createRef();
    _this.inputRef = /*#__PURE__*/React.createRef();
    _this.handleSearch = function (query) {
      if (_this.props.debugMode) {
        console.log('this.cache', _this.cache);
        console.log('query', query);
      }
      if (_this.cache[query]) {
        _this.setState({
          options: _this.cache[query].options
        });
        return;
      }
      _this.setState({
        isLoading: true
      });
      _this.props.makeAndHandleRequest(query).then(function (response) {
        _this.cache[query] = Object.assign({}, response, {
          page: 1
        });
        _this.setState({
          isLoading: false,
          options: response.options
        });
        if (_this.props.debugMode) {
          console.log('Response:', response);
        }
      });
    };
    _this.handleSelectionChange = function (selected) {
      // console.log('selection changed', selected)
      var labelKey = _this.props.labelKey;
      // not handling allowMultiple just yet
      return _this.setState({
        selected: selected
      }, function () {
        if (selected.length > 0) {
          if (typeof labelKey == 'string') {
            _this.inputRef.value = selected[0][labelKey];
          } else {
            // labelKey is a function
            _this.inputRef.value = labelKey(selected[0]);
          }
        } else {
          _this.inputRef.value = '';
        }
      });
    };
    _this.state = _this.getInitialState();
    return _this;
  }
  var _proto = Async.prototype;
  _proto.getInitialState = function getInitialState() {
    var _this$props = this.props,
      handleRenderMenuItemChildren = _this$props.handleRenderMenuItemChildren,
      handleRenderMenu = _this$props.handleRenderMenu;
    return Object.assign({
      isLoading: false,
      options: [],
      query: '',
      selected: []
    }, handleRenderMenuItemChildren && {
      renderMenuItemChildren: handleRenderMenuItemChildren
    }, handleRenderMenu && {
      renderMenu: handleRenderMenu
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      allowMultiple = _this$props2.allowMultiple,
      autoFocus = _this$props2.autoFocus,
      className = _this$props2.className,
      debugMode = _this$props2.debugMode,
      id = _this$props2.id,
      labelKey = _this$props2.labelKey,
      minLength = _this$props2.minLength,
      maxResults = _this$props2.maxResults,
      placeholder = _this$props2.placeholder,
      notifyOnChange = _this$props2.notifyOnChange,
      props = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    if (debugMode) {
      console.log('Typeahead state:', this.state);
    }
    return /*#__PURE__*/React.createElement(AsyncTypeahead, _extends({}, this.state, {
      autoFocus: autoFocus,
      id: id,
      className: className,
      labelKey: labelKey,
      maxResults: maxResults,
      multiple: allowMultiple,
      minLength: minLength,
      onChange: this.handleSelectionChange,
      onInputChange: function onInputChange(query) {
        return _this2.setState({
          query: query
        }, function () {
          return notifyOnChange(query);
        });
      },
      onSearch: this.handleSearch,
      placeholder: placeholder,
      ref: this.typeaheadRef,
      renderInput: function renderInput(_ref) {
        var inputRef = _ref.inputRef,
          referenceElementRef = _ref.referenceElementRef,
          inputProps = _objectWithoutPropertiesLoose(_ref, _excluded2);
        var input = {
          autoComplete: 'off',
          onBlur: inputProps.onBlur,
          onChange: inputProps.onChange,
          onFocus: inputProps.onFocus,
          onKeyDown: inputProps.onKeyDown
        };
        return /*#__PURE__*/React.createElement(FormSearch, {
          isDirty: !isEmpty(_this2.state.query),
          isSearching: _this2.state.isLoading,
          onClear: function onClear() {
            _this2.typeaheadRef.current.clear();
            _this2.inputRef.value = '';
            _this2.setState(_this2.getInitialState, function () {
              return notifyOnChange('');
            });
          }
        }, /*#__PURE__*/React.createElement(FormInput, {
          input: input,
          ref: function ref(node) {
            inputRef(node);
            referenceElementRef(node);
            _this2.inputRef = node;
          }
        }));
      },
      useCache: false
    }, props));
  };
  return Async;
}(Component);
Async.defaultProps = {
  autoFocus: false,
  notifyOnChange: function notifyOnChange(value) {
    return value;
  }
};
Async.propTypes = {
  /* Whether to allow more than one item to be selected */
  allowMultiple: PropTypes.bool,
  autoFocus: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /* To see helpful console logs */
  debugMode: PropTypes.bool,
  /* Unique identifier for Async */
  id: PropTypes.string.isRequired,
  handleRenderMenu: PropTypes.func,
  handleRenderMenuItemChildren: PropTypes.func,
  /* Value to key options selected by */
  labelKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  maxResults: PropTypes.number,
  minLength: PropTypes.number,
  /* passes query options */
  makeAndHandleRequest: PropTypes.func.isRequired,
  notifyOnChange: PropTypes.func,
  placeholder: PropTypes.string,
  /* will position the menu using fixed instead of absolute positioning */
  positionFixed: PropTypes.bool
};

export { Async as default };
//# sourceMappingURL=Async.js.map
